module.exports = __webpack_public_path__ + "img/kv-sub-title.e6f6bc0d.png";